/**
 * Reading a typed time (the working-hours grid, 03/11/2026 — Rob 1A: pick from a list in 15-minute
 * steps, or type it; no browser clock pop-up). Pure, and checked: `node src/lib/timeText.checks.mjs`.
 *
 *   "9" → "09:00"   "930" → "09:30"   "1330" → "13:30"   "13:30" → "13:30"   "9.15" → "09:15"
 *   "5:45pm" → "17:45"   "9am" → "09:00"   "12pm" → "12:00"   "12am" → "00:00"   (Rob 5A, 04/11/2026)
 *   "" or nonsense → null (the field puts its old value back; nothing is saved)
 */
export function parseTime(raw) {
  let s = String(raw ?? '').trim().toLowerCase();
  // am / pm on the end ("5:45pm", "9 am", "5.45 p.m."): 1–12 only, 12am is midnight, 12pm noon.
  const ampm = /^(.*?)\s*([ap])\.?\s*m\.?$/.exec(s);
  if (ampm) s = ampm[1].trim();
  s = s.replace(/[.\s]/g, ':');
  if (!s) return null;
  let h; let m;
  const colon = /^(\d{1,2}):(\d{1,2})$/.exec(s);
  if (colon) {
    h = Number(colon[1]); m = Number(colon[2]);
  } else if (/^\d{1,4}$/.test(s)) {
    if (s.length <= 2) { h = Number(s); m = 0; } else { h = Number(s.slice(0, -2)); m = Number(s.slice(-2)); }
  } else {
    return null;
  }
  if (ampm) {
    if (!(h >= 1 && h <= 12)) return null;
    h = (h % 12) + (ampm[2] === 'p' ? 12 : 0);
  }
  if (!(h >= 0 && h <= 23 && m >= 0 && m <= 59)) return null;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

/** Every time of day in 15-minute steps, "00:00" … "23:45". */
export const QUARTER_HOURS = Array.from({ length: 96 }, (_, i) =>
  `${String(Math.floor(i / 4)).padStart(2, '0')}:${String((i % 4) * 15).padStart(2, '0')}`);

/** The quarter-hour nearest a time, so the list opens where the box already is. */
export function nearestQuarter(hhmm) {
  const t = parseTime(hhmm);
  if (!t) return '09:00';
  const [h, m] = t.split(':').map(Number);
  const q = Math.min(95, Math.round((h * 60 + m) / 15));
  return QUARTER_HOURS[q];
}
